import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import { PreviewCover } from "src/components/CoverPhotoOrVideoPicker/PreviewCover";
import { SelectCover } from "src/components/CoverPhotoOrVideoPicker/SelectCover";
import {
  CoverPhotoOrVideoPickerProps,
  CoverOption,
} from "src/components/CoverPhotoOrVideoPicker/types";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { spacing } from "src/theme/spacing";

const CoverPhotoOrVideoPickerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${spacing.m};

  ${cssForMediaSize({
    min: MediaSize.MEDIUM_LARGE,
    css: css`
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-gap: ${spacing.m};
    `,
  })}

  > * {
    min-width: 0;
  }
`;

export const CoverPhotoOrVideoPicker: React.FCC<
  CoverPhotoOrVideoPickerProps
> = (props) => {
  const [coverOption, setCoverOption] = useState(
    // set initial cover option based on whether a video is present
    props.coverYoutubeVideoId
      ? CoverOption.VIDEO
      : props.allowDefaultCoverImage &&
        props.defaultCoverImageId === props.coverImageId
      ? CoverOption.DEFAULT
      : CoverOption.PHOTO
  );
  useEffect(() => {
    // Video takes precedence, so if they want photo only we must set Video to null.
    // You can have both a cover image and a video - then the cover image will
    // be used for opengraph previews and for Desktop donation flow.
    if (coverOption === CoverOption.PHOTO) {
      props.setCoverYoutubeVideoId(null);
    } else if (coverOption === CoverOption.DEFAULT) {
      props.setCoverYoutubeVideoId(null);
      props.setCoverImageId(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coverOption, props.setCoverYoutubeVideoId, props.setCoverImageId]);

  return (
    <CoverPhotoOrVideoPickerContainer>
      <PreviewCover
        coverOption={coverOption}
        setCoverOption={setCoverOption}
        {...props}
      />
      <SelectCover
        coverOption={coverOption}
        setCoverOption={setCoverOption}
        {...props}
      />
    </CoverPhotoOrVideoPickerContainer>
  );
};
